import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";
import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { QualityPillars } from "@/components/landing/QualityPillars";
import { Highlights } from "@/components/landing/Highlights";
import { Apartments } from "@/components/landing/Apartments";
import { ApartmentsCompare } from "@/components/landing/ApartmentsCompare";
import { AusstattungKomfort } from "@/components/landing/AusstattungKomfort";
import { ConstructionTracker } from "@/components/landing/ConstructionTracker";
import { ExteriorGallery } from "@/components/landing/ExteriorGallery";
import { InteriorGallery } from "@/components/landing/InteriorGallery";
import { Energy } from "@/components/landing/Energy";
import { MortgageCalculator } from "@/components/landing/MortgageCalculator";
import { RentalYieldForecast } from "@/components/landing/RentalYieldForecast";
import { Funding } from "@/components/landing/Funding";
import { Location } from "@/components/landing/Location";
import { BuyingTimeline } from "@/components/landing/BuyingTimeline";
import { FAQ } from "@/components/landing/FAQ";
import { BauherrArchitekt } from "@/components/landing/BauherrArchitekt";
import { Contact } from "@/components/landing/Contact";
import { DeveloperNote } from "@/components/landing/DeveloperNote";
import { ProjectBulkPurchase } from "@/components/landing/ProjectBulkPurchase";
import { Footer } from "@/components/landing/Footer";
import { Reveal } from "@/hooks/useReveal";
import { SeoHead } from "@/components/SeoHead";
import { APARTMENT_SEO, DEFAULT_SEO, resolveSeo } from "@/data/apartmentSeo";
import { useLang } from "@/i18n/LanguageProvider";

const FALLBACK_COMPANY = {
    name: "G21 Projekt GmbH",
    phone: "+49 6134 28 63 266",
    email: "buero@neubau-kaufen-wiesbaden.de",
    address: "Gaugasse 19, 65203 Wiesbaden",
    project_address: "Gaugasse 21, 65203 Wiesbaden",
};

export default function LandingPage() {
    const [company, setCompany] = useState(FALLBACK_COMPANY);
    const { slug } = useParams();
    const { lang } = useLang();
    const aptSeo = slug ? APARTMENT_SEO[slug] : null;
    const seo = resolveSeo(aptSeo || DEFAULT_SEO, lang);
    const focusApartmentId = aptSeo ? aptSeo.apartmentId : null;

    useEffect(() => {
        api.get("/company")
            .then((r) => setCompany({ ...FALLBACK_COMPANY, ...(r.data || {}) }))
            .catch(() => setCompany(FALLBACK_COMPANY));
    }, []);

    return (
        <main className="bg-cream" data-testid="landing-page">
            <SeoHead seo={seo} />
            <Navbar />
            <Hero />
            <Reveal><QualityPillars /></Reveal>
            <Reveal><Highlights /></Reveal>
            <Reveal><Apartments focusApartmentId={focusApartmentId} /></Reveal>
            <Reveal><ApartmentsCompare /></Reveal>
            <Reveal><AusstattungKomfort /></Reveal>
            <Reveal><ConstructionTracker /></Reveal>
            <Reveal><ExteriorGallery /></Reveal>
            <Reveal><InteriorGallery /></Reveal>
            <Reveal><Energy /></Reveal>
            <Reveal><MortgageCalculator /></Reveal>
            <Reveal><RentalYieldForecast /></Reveal>
            <Reveal><Funding /></Reveal>
            <Reveal><Location /></Reveal>
            <Reveal><BuyingTimeline /></Reveal>
            <Reveal><FAQ /></Reveal>
            <Reveal><BauherrArchitekt company={company} /></Reveal>
            <Reveal><Contact company={company} /></Reveal>
            <Reveal><ProjectBulkPurchase /></Reveal>
            <Reveal><DeveloperNote company={company} /></Reveal>
            <Footer company={company} />
        </main>
    );
}
